import ky from 'ky';
import { parse } from 'query-string';

import extendOrInitSession from './extendOrInitSession';
import getGeneralFields from './getGeneralFields';

import { TRACKING_EVENT__PAGE_VIEW, TRACKING_OPERATION__SYSCTL } from './constants';

/**
 * 傳送 pageview 事件：
 * 先延長或建立新的 session，
 * 將 session ID 及 metadata 傳送到後端。
 */
export default async function sendPageView() {
  await extendOrInitSession();

  /** @see {@link https://docs.google.com/spreadsheets/d/1OMhlNt-5jTx0Z-LNWI3O_3EbijNopKBE_SdsHPU3Jmw/edit#gid=401880768} */
  const payload = {
    ...(await getGeneralFields()),
    event: TRACKING_EVENT__PAGE_VIEW,
    op: TRACKING_OPERATION__SYSCTL,
    op_meta: parse(location.search),
  };

  await ky.post(`${process.env.TRACKING_API_HOST}/v1/event`, { json: payload, throwHttpErrors: false });
}
